module.exports = __webpack_public_path__ + "img/step9.89632c81.png";